<template>
  <div class="card indie-manager">
    <div class="card-header clearfix">
      <div class="pull-left">
        <img src="/static/img/robot-avatar.png" width="22" class="mr-1"> IndieManager <span class="badge ml-1" v-if="!user.subscription">Basic</span><span v-if="user.subscription" class="badge badge-success ml-1">PRO</span>
      </div>
      <div class="pull-right">
        {{ currentChats }} {{ $t('of') }} {{ limit }} <span class="d-none d-md-inline">{{ $t('messages_today') }}</span>
      </div>
    </div>
    <div class="card-body">
      <div ref="chatContainer" class="form-control chat-container" style="width: 100%:" rows="5">
        <div v-for="(item, index) in chat" v-bind:key="`chat_${index}`" class="mb-1">
          <span class="text-success" v-if="item.from === 'user'"><b class="mr-1">{{ $t('you') }}:</b> {{ item.content }}</span>
          <span v-if="item.from === 'bot'"><b class="mr-1">IndieManager:</b> {{ item.content }}</span>
        </div>
        <div v-if="!user.subscription && currentChats >= limit" class="mt-2 label label-info">
          <router-link to="/upgrade?from=ai-manager">{{ $t('upgrade_now') }}</router-link> {{ $t('to_unlock_questions') }}.
        </div>
        <div v-if="!chat.length && currentChats < limit">
          <b class="mr-1">IndieManager:</b> {{ $t('ask_about_your_music') }}
        </div>
        <div v-if="showCreateArtistButton" class="mt-2">
          <router-link to="/artists" class="btn btn-default btn-sm">{{ $t('create_artist') }}</router-link>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <form class="input-group" @submit.prevent="sendMessage()">
        <input :placeholder="getPlaceholder()" type="text" :disabled="loading || currentChats >= limit" v-model="text" class="form-control">
        <button type="submit" :disabled="loading || currentChats >= limit" class="btn input-group-append">
          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
          <span v-if="!loading">{{ $t('send') }}</span>
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import AI from '../services/ai'
import Artists from '../services/artists'
import _ from 'underscore'

export default {
  name: 'AIManager',
  data: function () {
    return {
      showUpgradeMessage: false,
      showCreateArtistButton: false,
      hasArtist: false,
      limit: 0,
      loading: true,
      text: '',
      user: {},
      history: '',
      chat: []
    }
  },
  computed: {
    currentChats: function () {
      return _.filter(this.chat, item => item.from === 'bot' && !item.local).length
    }
  },
  methods: {
    getPlaceholder: function () {
      let placeholder = ''

      if (this.currentChats >= this.limit) {
        placeholder = this.$t('chat_limit_reached')
      }

      return placeholder
    },
    scroll: function () {
      setTimeout(() => {
        this.$refs.chatContainer.scrollTop = this.$refs.chatContainer.scrollHeight
      }, 5)
    },
    initChat: function () {
      AI.getHistory().then(response => {
        this.limit = response.data.limit

        _.each(response.data.items, item => {
          this.chat.push({ from: 'user', content: item.input, local: true })
          this.chat.push({ from: 'bot', content: item.response })
        })

        this.scroll()
        this.loading = false
      })
    },
    sendMessage: function () {
      if (!this.text.trim()) return

      if (!this.hasArtist) {
        this.text = ''
        this.showCreateArtistButton = true
        return this.chat.push({ from: 'bot', content: this.$t('artist_needed'), local: true })
      }

      this.loading = true
      this.history += this.text
      this.chat.push({ from: 'user', content: this.text, local: true })
      this.text = ''

      this.scroll()

      AI.askManager(this.history).then(response => {
        this.chat.push({ from: 'bot', content: response.data.result })
        this.history += response.data.result + '\n'
        this.loading = false
        this.scroll()
      }).catch(error => {
        this.chat.push({ from: 'bot', content: this.$t('many_requests'), local: true })
        this.loading = false
        console.error(error)
      })
    }
  },
  mounted: function () {
    this.initChat()
  },
  created: function () {
    this.user = this.$user

    Artists.getAll({ limit: 1 }).then((response) => {
      this.hasArtist = response.data.length
    })
  },
  components: {
  },
  filters: {
  }
}
</script>
<style lang="scss" scoped>
.chat-container {
  overflow-y: auto;
  padding-bottom: 10px;
  height: 120px !important;
}

.indie-manager .form-control:disabled {
  background-color: #eee !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AIManager.vue